"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FindItem = FindItem;
exports.SureFindItem = SureFindItem;
function FindItem(items, uuid) {
    return items.find((item) => item.uuid === uuid);
}
function SureFindItem(items, uuid) {
    return FindItem(items, uuid);
}
